const isAbsoluteUrlRegEx = new RegExp(
  /^(http[s]?:\/\/)?[a-z0-9]{2,}(\.[a-z0-9]{2,})/gi,
);

export const isAbsoluteUrl = (url: string) => url.match(isAbsoluteUrlRegEx);
